import type { ReactNode } from 'react'

// Monospace pill for IDs, action names, and other operator-facing
// identifiers. Selectable so an operator can copy the value with the
// keyboard. Renders an em-dash when the value is empty so empty cells
// don't collapse to zero-width.

interface CodeChipProps {
  children?: ReactNode
  className?: string
  title?: string
}

export function CodeChip({ children, className, title }: CodeChipProps) {
  const isEmpty = children === undefined || children === null || children === ''
  const cls = [
    'inline-flex max-w-full items-center rounded bg-stone-100 px-1.5 py-0.5',
    'font-mono text-xs text-stone-700 ring-1 ring-stone-200',
    'select-all break-all',
    className,
  ].filter(Boolean).join(' ')
  return (
    <code className={cls} title={title ?? (isEmpty ? undefined : String(children))}>
      {isEmpty ? '—' : children}
    </code>
  )
}
